export function changeToCorrectNumber(value: string) {
  if (value.length === 11 && value.at(0) !== '7') {
    return `7${value.slice(1)}`
  }
  if (value.length && value.at(0) !== '7') {
    return `7${value}`
  }

  return value
}
